import Session from "supertokens-web-js/recipe/session";

// This function checks if the factors are complete when logging into the web app with Supertokens
// When a user logs in the Supertokens context is "SESSION_CREATED". However, if that person is apart of an organisation with 2FA
// they will need to complete a 2nd factor. When the 2nd factor is completed, the Supertokens context is "ACCESS_TOKEN_PAYLOAD_UPDATED"
export async function checkFactorsComplete() {
  const session = await Session.doesSessionExist();

  if (session) {
    // this will return an array of factors that need to be completed, if none it is an empty array
    const claims = await Session.validateClaims();

    return claims.length === 0;
  }

  return false;
}
